/**
 * AW Slideshow block — Embla init + dots + theme editor support
 */

(function () {
  function initDots(el, embla) {
    var container = el.querySelector('[data-aw-dots]');
    if (!container) return;

    var slides = embla.slideNodes();
    slides.forEach(function (_, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'aw-slideshow__dot';
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.addEventListener('click', function () { embla.scrollTo(i); });
      container.appendChild(btn);
    });

    function syncDots() {
      var idx = embla.selectedScrollSnap();
      container.querySelectorAll('.aw-slideshow__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    embla.on('select', syncDots);
    embla.on('reInit', function () {
      container.innerHTML = '';
      initDots(el, embla);
    });
    syncDots();
  }

  function initSlideshows(root) {
    (root || document).querySelectorAll('[data-aw-slideshow]').forEach(function (el) {
      if (el.dataset.awSlideshowInit) return;
      el.dataset.awSlideshowInit = '1';

      var plugins = [];
      if (el.dataset.autoplay === 'true' && typeof EmblaCarouselAutoplay !== 'undefined') {
        plugins.push(EmblaCarouselAutoplay({ delay: 3000 }));
      }

      var embla = initEmbla(el, {
        loop:     el.dataset.loop     === 'true',
        dragFree: el.dataset.dragFree === 'true',
      }, plugins);

      el._awEmbla = embla;

      if (embla && el.dataset.showDots === 'true') {
        initDots(el, embla);
      }

      el.dispatchEvent(new CustomEvent('aw:slideshow:init', { bubbles: true, detail: { embla: embla } }));
    });
  }

  // Scroll to the selected slide when editor focuses a block
  document.addEventListener('shopify:block:select', function (e) {
    var slideshow = e.target.closest('[data-aw-slideshow]');
    if (!slideshow || !slideshow._awEmbla) return;
    var slides = Array.from(slideshow.querySelectorAll('.embla__slide'));
    var idx = slides.indexOf(e.target.closest('.embla__slide'));
    if (idx > -1) slideshow._awEmbla.scrollTo(idx);
  });

  document.addEventListener('DOMContentLoaded', function () { initSlideshows(); });
  document.addEventListener('shopify:section:load', function (e) { initSlideshows(e.target); });
})();